import { Typography } from "@mui/material";

type TypographyVariants = "h6"

export interface ItemLabelProps {
    label: string;
    variant?: TypographyVariants
    required?: boolean;
}
export const ItemLabel = ({ label, required, variant }: ItemLabelProps) => {
    return (<>
        <Typography display={"inline"} variant={variant}>{label}</Typography>
        <RequiredIcon required={!!required} variant={variant} />
    </>)
}

interface RequiredIconProps {
    required?: boolean;
    variant?: TypographyVariants
}
export const RequiredIcon = ({ required, variant }: RequiredIconProps) => {
    if (required === false) {
        return null;
    }
    return <Typography variant={variant} color={"#F44"} display={"inline"} ml={1}>*</Typography>
}